import { __spreadArray, __assign } from 'tslib';
import { produce } from 'immer';
import { actions } from './actions.esm.js';
import { init } from './reducers/init.esm.js';

var initialState = {};
var defaultFilterState = {
    filters: {},
    displayedFilters: [],
    initialized: false
};
var reducer = produce(reducerFunction);
function reducerFunction(draft, action) {
    var name = action.payload.name;
    if (!name)
        throw "Name is required in the payload to ".concat(action.type, ". Make sure you passed a name to useFilters or wrapped your component in a FilterProvider");
    if (!draft[name] && action.type !== actions.init)
        throw "State not initialized for ".concat(name, ". Render a FilterBar with the name ").concat(name, " before trying to modify it.");
    switch (action.type) {
        case actions.init: {
            init(draft, action);
            break;
        }
        case actions.mergeFilters: {
            var filters = action.payload.filters;
            var mergedFilters = __assign(__assign({}, draft[name].filters), filters);
            var displayedFilters = getDisplayedFilters(mergedFilters, draft[name].displayedFilters);
            draft[name].filters = mergedFilters;
            draft[name].displayedFilters = displayedFilters;
            break;
        }
        case actions.replaceFilters: {
            var filters_1 = action.payload.filters;
            var filterKeys_1 = Object.keys(filters_1);
            draft[name].config.forEach(function (filter) {
                if (filter.required) {
                    if (!filterKeys_1.includes(filter.name))
                        filters_1[filter.name] = filters_1[filter.name] || filter.defaultValues;
                }
            });
            var displayedFilters = getDisplayedFilters(filters_1, draft[name].displayedFilters);
            draft[name].filters = filters_1;
            draft[name].displayedFilters = displayedFilters;
            break;
        }
        case actions.displayFilter: {
            if (draft[name].displayedFilters.includes(action.payload.filterName))
                return;
            var staticCount = draft[name].config.filter(function (conf) { return conf.static; }).length;
            draft[name].displayedFilters.splice(staticCount, 0, action.payload.filterName);
            break;
        }
        case actions.resetFilters: {
            var displayedFilters_1 = [];
            var filters_2 = {};
            draft[name].config.forEach(function (filter) {
                if (filter.defaultValues) {
                    displayedFilters_1.push(filter.name);
                    filters_2[filter.name] = filter.defaultValues;
                }
                else {
                    if (filter.static)
                        displayedFilters_1.push(filter.name);
                }
            });
            draft[name].filters = filters_2;
            draft[name].displayedFilters = displayedFilters_1;
            break;
        }
        case actions.removeFilter: {
            var displayedFilters = __spreadArray([], draft[name].displayedFilters, true);
            displayedFilters.splice(displayedFilters.indexOf(action.payload.filterName), 1);
            delete draft[name].filters[action.payload.filterName];
            draft[name].displayedFilters = displayedFilters;
            break;
        }
        case actions.remove: {
            delete draft[name];
            break;
        }
        default:
            console.info({ action: action });
            throw new Error("Unknown Action 👆");
    }
}
var getDisplayedFilters = function (filters, displayedFilters) {
    var clonedDisplay = __spreadArray([], displayedFilters, true);
    Object.keys(filters).forEach(function (filterName) {
        if (clonedDisplay.includes(filterName))
            return;
        clonedDisplay.push(filterName);
    });
    return clonedDisplay;
};

export { defaultFilterState, initialState, reducer };
//# sourceMappingURL=reducer.esm.js.map
